<template>
  <v-dialog
      v-model="isOpen"
      max-width="448px"
      persistent
  >
    <v-card
        :loading="isLoading"
    >
      <v-card-title>Cambiar estado de regalias</v-card-title>

      <v-divider></v-divider>

      <v-card-subtitle class="pt-5">
        Selecciona el nuevo estado de pago de regalías del dietista.
      </v-card-subtitle>

      <v-card-text>
        <v-form ref="royaltiesForm">
          <v-row>
            <v-col cols="12">
              <v-select
                  v-model="newRoyaltiesStatus"
                  :items="options"
                  label="Estado de pago de regalías"
                  hint="Selecciona el nuevo estado de pago de regalías del dietista."
                  persistent-hint
                  outlined
                  prepend-inner-icon="mdi-account-cash"
                  clearable
                  :rules="[rules.required]"
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <CancelButton @click="handleClose" :isLoading="isLoading"/>
        <v-spacer></v-spacer>
        <SaveButton @click="updateRoyaltiesStatus" :isLoading="isLoading"/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import CancelButton from "@/components/buttons/CancelButton.vue";
import SaveButton from "@/components/buttons/SaveButton.vue";
import UserService from "@/services/users/UserService";
import throwSuccessMessage from "@/utils/SuccessMessage";

export default Vue.extend({
  name: "DialogUpdateRoyalties",
  components: {
    SaveButton,
    CancelButton
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    username: {
      type: String,
      required: true,
    },
    royaltiesStatus: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      // Form
      newRoyaltiesStatus: this.royaltiesStatus as string,

      // Options
      options: [
        {text: 'Exento de pago', value: 'EXEMPT'},
        {text: 'Pendiente de pago', value: 'PENDING'},
        {text: 'Pagado', value: 'PAID'},
      ],

      // Loading
      isLoading: false as boolean,

      // Validation
      rules: {
        required: (value: string) => !!value || 'Campo requerido',
      }
    };
  },
  computed: {
    isOpen: {
      get(): boolean {
        return this.value;
      },
    },
  },
  methods: {
    async updateRoyaltiesStatus() {
      this.isLoading = true;
      try {
        const body = {
          username: this.username,
          royaltiesStatus: this.royaltiesStatus,
        }
        await UserService.updateRoyaltiesStatus(body);
        throwSuccessMessage("Estado de pago de regalías actualizado exitosamente");
        this.$emit("updated");
        this.handleClose();
      } finally {
        this.isLoading = false;
      }
    },
    handleClose() {
      const form = this.$refs.royaltiesForm as any;
      form.resetValidation();
      this.$emit("input", false);
    },
  },
});
</script>

<style scoped>

</style>